import React from "react";
import { Col, Row, Button, Modal } from "react-bootstrap";
import { Formik, Form } from "formik";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import * as Yup from "yup";
import { CircularProgress } from "@material-ui/core";
import { updateUserBuyerDetail } from "../../redux";
import moment from "moment";

const BuyerDetails = ({ showEditTemplete, setShowEditTemplate }) => {
  const { selectedUser } = useSelector(
    (state) => state.userManagement,
    shallowEqual
  );

  const dispatch = useDispatch();

  const redirectBack = () => {
    setShowEditTemplate(false);
  };

  const editUserBuyerSchema = Yup.object().shape({
    name: Yup.string()
      .trim()
      .notOneOf(
        ["null", "NULL", "Null", "Undefined", "undefined"],
        "Please enter name"
      )
      .required("Please enter name"),
    surname: Yup.string()
      .trim()
      .notOneOf(
        ["null", "NULL", "Null", "Undefined", "undefined"],
        "Please enter surname"
      )
      .required("Please enter surname"),
  });

  const userDetails = selectedUser?.userBuyerDetail || {};
  const userId = selectedUser?._id || null;

  return (
    <>
      <Modal
        size="lg"
        show={showEditTemplete}
        onHide={() => setShowEditTemplate(false)}
        centered
        className="def_modal mx-auto"
        enforceFocus={false}
      >
        <Modal.Header closeButton>
          <Modal.Title className="fn_s_18 color_blk f-w-700">
            Edit User Buyer Detail
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Formik
            enableReinitialize
            initialValues={{
              name: userDetails.name || "",
              surname: userDetails.surname || "",
              user_id: userId,
            }}
            validationSchema={editUserBuyerSchema}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              setSubmitting(true);
              dispatch(
                updateUserBuyerDetail(
                  values,
                  setSubmitting,
                  resetForm,
                  redirectBack
                )
              );
            }}
          >
            {({
              values,
              errors,
              touched,
              isSubmitting,
              handleBlur,
              handleChange,
            }) => (
              <Form>
                <Row className="mb-3">
                  {/* Name Field */}
                  <Col md={6}>
                    <div className="form-group">
                      <label className="form-label">Name</label>
                      <input
                        placeholder="Enter Name"
                        type="text"
                        name="name"
                        className={`form-control re_inputRouded border-less-input ${
                          errors.name && touched.name ? "is-invalid" : ""
                        }`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.name}
                      />
                      {touched.name && errors.name && (
                        <div className="fv-help-block text-danger">
                          {errors.name}
                        </div>
                      )}
                    </div>
                  </Col>

                  {/* Surname Field */}
                  <Col md={6}>
                    <div className="form-group">
                      <label className="form-label">Surname</label>
                      <input
                        placeholder="Enter Surname"
                        type="text"
                        name="surname"
                        className={`form-control re_inputRouded border-less-input ${
                          errors.surname && touched.surname ? "is-invalid" : ""
                        }`}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        value={values.surname}
                      />
                      {touched.surname && errors.surname && (
                        <div className="fv-help-block text-danger">
                          {errors.surname}
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>

                {/* Disabled Fields */}
                <Row className="mb-3">
                  {[
                    { label: "Email", value: userDetails.email },
                    { label: "Mobile Number", value: userDetails.mobileNumber },
                    { label: "Document Type", value: userDetails.documentType },
                    {
                      label: "Document Number",
                      value: userDetails.documentNumber,
                    },
                    {
                      label: "Date of Birth",
                      value: userDetails?.DOB
                        ? moment(userDetails.DOB).format("DD/MM/YYYY")
                        : "-",
                    },
                    { label: "Country", value: userDetails.country },
                    { label: "City", value: userDetails.city },
                    { label: "Address", value: userDetails.address },
                    { label: "Zip Code", value: userDetails.zipCode },
                  ].map((field, index) => (
                    <Col md={6} key={index}>
                      <div className="form-group">
                        <label className="form-label">{field.label}</label>
                        <input
                          type="text"
                          className="form-control re_inputRouded border-less-input"
                          value={field.value || "-"}
                          disabled
                        />
                      </div>
                    </Col>
                  ))}
                </Row>

                {/* Submit Button */}
                <div className="form-group  mb-0 mt-4">
                  <div className="form-group mr-5 mb-1 mt-2 bg-dark">
                    <button
                      type="submit"
                      className="btn btn-blue spinnerBtn add-avtar-btn"
                      disabled={isSubmitting}
                    >
                      <span>Update</span>
                      {isSubmitting && (
                        <div className="ml-3 basic-verification-loader text-center">
                          <CircularProgress />
                        </div>
                      )}
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default BuyerDetails;
